export default "__VITE_ASSET__CYluW6HR__"